import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  CashBackToCardMembership,
  CashRedemptionOrderItemData,
  Enrollment,
} from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentHelper {
  constructor(protected translateService: TranslateService) {}

  displayedAccountNumber(enrollmentAccountNumber: string): string {
    return enrollmentAccountNumber;
  }

  productTypeFromProductCode(enrollment: Enrollment): string {
    if (!!enrollment.groupName) {
      return enrollment.groupName;
    }

    switch (enrollment.productCode) {
      case 'ASCENDA_GO.TRANSAC':
        return 'AscendaGo Transaction Account';
      case 'ASCENDA_GO.SAVINGS':
        return 'AscendaGo Savings Account';
      // TODO: maybe we need to return default value here
      default:
        return 'Bank account';
    }
  }

  userHasProductsOtherThanSuppCard(enrollments: Enrollment[]): boolean {
    return (
      enrollments.filter(
        (enrollment: Enrollment) =>
          enrollment.cardholderType !== 'supplementary',
      ).length !== 0
    );
  }

  selectedEnrollmentAccountAriaLabelInConfirmationPage(
    metaData: CashRedemptionOrderItemData,
  ): string {
    const cashbackToCardMemebership =
      metaData.membership as CashBackToCardMembership;
    return this.translateService.instant(
      'accessibility.redeem_cash_v2.success.redeem_to_card',
      {
        loyaltyProgram: cashbackToCardMemebership.details.groupName,
        digits: cashbackToCardMemebership.number.substr(-4),
      },
    );
  }
}
